import { render } from "./affiliate-entrepreneur-results.vue?vue&type=template&id=3c91e95f&scoped=true&ts=true"
import script from "./affiliate-entrepreneur-results.vue?vue&type=script&lang=ts"
export * from "./affiliate-entrepreneur-results.vue?vue&type=script&lang=ts"

import "./affiliate-entrepreneur-results.vue?vue&type=style&index=0&id=3c91e95f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c91e95f"]])

export default __exports__